import decrypt from './decrypt';

export default {
  decrypt,
};



// WEBPACK FOOTER //
// ./src/services/account/index.js